import { render, staticRenderFns } from "./ProjectManagerInvite.vue?vue&type=template&id=11b943d6&"
import script from "./ProjectManagerInvite.vue?vue&type=script&lang=js&"
export * from "./ProjectManagerInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports